import React from "react";
import { Subscribe } from "unstated";
import PlayerContainer from "../state";
import { Header } from "./header";
import { Buttons } from "./buttons";
import { RagaSelector } from "./raga-selector";
import {ShrutiSelector} from "./shruti-selector";
import { ShowSthana } from "./checkbox";


export default class Layout extends React.Component {
  render() {
    return (<div>
      <Header />
      <div className="container has-background-light" style={{ paddingTop: 0 }}>
        <section className="section">
          <div className="columns">
          <div className="column is-one-third">
          <p style={{color: "#182C61"}}>Shruti | Octave | Kaalam</p>
          <ShrutiSelector />
          
          </div>
          <div className="column is-one-quarter">
          <p style={{color: "#182C61"}}><ShowSthana /></p>
          </div>
          
            <div className="column">
              <p style={{color: "#182C61"}}>Examples:</p>
              <RagaSelector ragas={this.props.ragas} />
            </div>

          </div>
        </section>
      </div>
      <div className="container">
        <section className="section">
          <Subscribe to={[PlayerContainer]}>
            {playerContainer => {
              console.log("noteinText ", playerContainer.state.noteinText);
              let isHidden = playerContainer.state.noteinText.length > 0 ? "" : "is-hidden";
              return (
                <>
                  <div className={`buttons ${isHidden}`}>
                    <div className="button is-success play" onClick={() => playerContainer.play()}>Play</div>
                    <div className="button is-danger stop" onClick={() => playerContainer.stop()} >Stop</div>
                  </div>
                  <div className="field is-grouped">

                    <div style={{ marginTop: "0.5em", marginRight: "1em" }}>
                      {playerContainer.state.noteinText.join(" ")}
                    </div>
                    <button className={`button is-text ${isHidden}`} style={{ textDecoration: "underline" }} onClick={() => playerContainer.clear()}>Clear</button>
                    <button className={`button ${isHidden}`}
                      onClick={() => playerContainer.delSwara()}><i className="fas fa-backspace"></i></button>
                  </div>
                </>
              )
            }
            }
          </Subscribe>
          <Buttons />


        </section>
      </div>
    </div>);
  }
}